module.exports = __webpack_public_path__ + "static/media/fondo_dj.67c2ae60.jpg";